import { render, staticRenderFns } from "./memberTab.vue?vue&type=template&id=073fad2a&lang=pug"
import script from "./memberTab.vue?vue&type=script&lang=js"
export * from "./memberTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports